import { render, staticRenderFns } from "./HOG1060.vue?vue&type=template&id=20712758&scoped=true&"
import script from "./HOG1060.vue?vue&type=script&lang=js&"
export * from "./HOG1060.vue?vue&type=script&lang=js&"
import style0 from "./HOG1060.vue?vue&type=style&index=0&id=20712758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20712758",
  null
  
)

export default component.exports